module.exports = __webpack_public_path__ + "img/aris-limassol-logo-icon.94feb8b7.png";